import { useState, useEffect } from 'react';
import api from '../api/axios';
import { VITRINE_DEFAULTS } from '../constants/vitrineDefaults';

export function useVitrine() {
  const [vitrine, setVitrine] = useState(VITRINE_DEFAULTS);

  useEffect(() => {
    let cancelled = false;
    api.get('/vitrine')
      .then(res => {
        if (!cancelled) setVitrine({ ...VITRINE_DEFAULTS, ...res.data });
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return vitrine;
}
